import { handleResponseError } from '@/Helpers.js';
import Model from '@/models/Model.js';

export default class Location extends Model {
    static entity = 'locations';

    static modelName = 'Location';

    static fields() {
        return {
            id: this.attr(null),
            external_id: this.attr(null),
            course_key_id: this.attr(null),
            location_type_id: this.attr(null),
            parent_id: this.attr(null),
            primary_contact_id: this.attr(null),
            name: this.attr(null),
            capacity: this.attr(null),
            address_1: this.attr('2041 Business Center Dr'),
            address_2: this.attr(null),
            city: this.attr('Irvine'),
            state: this.attr('CA'),
            postal_code: this.attr('92612'),
            country: this.attr(null),
            coordinates: this.attr(null),
            is_offsite: this.boolean(false),
            is_active: this.boolean(true),
            time_periods_count: this.attr(null),
            upcoming_time_periods_count: this.attr(null),

            ...super.fields(),

            location_type: this.belongsTo('location_types', 'location_type_id'),
            parent: this.belongsTo('locations', 'parent_id'),
            primary_contact: this.belongsTo('contacts', 'primary_contact_id'),
            location_groups: this.hasMany('location_groups', 'location_id'),
            groups: this.belongsToMany('groups', 'location_groups', 'location_id', 'group_id'),
            contacts: this.belongsToMany('contacts', 'location_contacts', 'location_id', 'contact_id'),
        };
    }

    static searchable() {
        return ['name', 'address_1', 'city', 'state', 'postal_code', 'country'];
    }

    get title() {
        if (this.parent) {
            return `${this.parent.name} - ${this.name}`;
        }

        return this.name;
    }

    get has_address() {
        return this.address_1 && this.city && this.state && this.postal_code;
    }

    get full_address() {
        let address = `${this.address_1} ${this.address_2}<br />${this.city}, ${this.state} ${this.postal_code}`;

        if (this.country !== 'USA' && this.country !== 'USA' && this.country !== 'United States') {
            address += `<br />${this.country}`;
        }

        return address;
    }

    get route() {
        return { name: 'location-view', params: { locationId: this.id } };
    }

    async autosave() {
        await Location.store().dispatch('AutoSave/setSaving', {
            type: 'entities/locations',
            id: this.id,
        });

        try {
            await Location.api().put(`/api/locations/${this.id}`, this.$toJson(), {
                errorHandle: false,
                save: false,
            });

            await Location.store().dispatch('AutoSave/setSaved', {
                type: 'entities/locations',
                id: this.id,
            });
        } catch (e) {
            handleResponseError(e);

            await Location.store().dispatch('AutoSave/setError', {
                indicator: 'entities/locations',
                error: { message: 'Invalid' },
                id: this.id,
            });
        }
    }
}
